var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIconGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellow-grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#DF7C2C",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#F1CE6B",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/cards/status/\\u041F\\u0440\\u043E\\u0431\\u043B\\u0435\\u043C\\u0430"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2415325,19.5867329 C16.2415325,19.3418435 16.2446863,19.095903 16.2404812,18.8510135 C16.2352248,18.5220419 16.0312775,18.3160404 15.7022285,18.3128874 C15.2386163,18.3076322 14.7750041,18.3076322 14.3124431,18.3128874 C14.0044196,18.3160404 13.7868057,18.5104806 13.7783955,18.8163296 C13.7647289,19.3208229 13.7647289,19.8253162 13.7773442,20.3298095 C13.7857544,20.6304034 13.9939069,20.8290476 14.2882638,20.8343028 C14.7718502,20.8406089 15.2564879,20.84166 15.7390231,20.8332517 C16.0354826,20.8279966 16.232071,20.6198931 16.2404812,20.3235033 C16.2457376,20.0775628 16.2415325,19.8316224 16.2415325,19.5867329 M16.2415325,13.4718539 C16.2415325,12.4471019 16.2425837,11.4223499 16.2415325,10.3975979 C16.2415325,10.0118707 16.052303,9.81743061 15.6654338,9.81112445 C15.2281035,9.80481828 14.7907732,9.80376725 14.3534429,9.81007342 C13.9728814,9.81637959 13.7731391,10.0181769 13.7731391,10.3996999 C13.7710366,12.4428978 13.7710366,14.4850445 13.7741904,16.5282424 C13.7741904,16.9276329 13.9833941,17.1283792 14.3870836,17.1315322 C14.8033885,17.1336343 15.2207446,17.1336343 15.6370494,17.1304812 C16.0449441,17.1262771 16.2404812,16.930786 16.2415325,16.5250893 C16.2425837,15.5076945 16.2415325,14.4892487 16.2415325,13.4718539 M14.9999769,24 C10.0379597,23.9968451 6.01052575,19.970358 6,15.0042522 C5.99160281,10.0455036 10.0631902,5.97697547 15.0115409,6 C19.9903785,6.02322068 24.0178124,10.058116 24,15.0053032 C23.9831204,19.9808683 19.9588403,24.0031512 14.9999769,24",
    id: "icon",
    fill: "url(#yellow-grad)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconGradient);
export default __webpack_public_path__ + "static/media/error-icon-gradient.55afb09e.svg";
export { ForwardRef as ReactComponent };